<template>
  <div>
    <div class="d-flex justify-content-end">
      <form class="form-inline py-2" @submit.prevent>
        <div class="input-group with-clear-icon">
          <input type="text" class="form-control" v-model="searchText" />
          <i
            class="ico ico-close"
            @click="clearSearchText"
            v-if="searchText.length > 0"
          ></i>
          <div class="input-group-append">
            <span class="input-group-text">
              <i class="fa fa-search"></i>
            </span>
          </div>
        </div>
      </form>
    </div>
    <table class="table table-responsive">
      <thead>
        <tr>
          <th
            v-for="column in columns"
            :key="column.field"
            class="px-4"
            :class="{
              'sort-asc': column.field === sortFieldName && sortType === 'ASC',
              'sort-desc':
                column.field === sortFieldName && sortType === 'DESC',
              sort: column.field !== sortFieldName,
            }"
            @click="sortTable(column.field)"
          >
            {{ column.name }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="customer in filteredCustomers" :key="customer.id">
          <td v-for="column in columns" :key="column.field" class="px-4">
            <template v-if="column.field === 'status'">
              <onoff-toggle
                :value="customer[column.field]"
                @input="(value) => toggleCustomerStatus(value, customer.id)"
                theme="material"
                thumbColor="#28bd8b"
              />
              <span class="ml-3">{{
                customer[column.field] ? "Активирован" : "Деактивирован"
              }}</span>
            </template>
            <template v-else-if="column.field === 'plan'">
              <select
                class="form-control custom-select ml-2"
                :value="customer[column.field]"
                @change="(event) => changePlan(customer.id, event.target.value)"
                id="plan"
              >
                <option
                  v-for="plan in plans"
                  :key="plan.name"
                  :value="plan.id"
                  :selected="plan.id === customer[column.field]"
                >
                  {{ plan.name }}
                </option>
              </select>
            </template>
            <template v-else-if="column.field === 'name'">
              <router-link :to="`/admin/company/${customer.id}`">{{customer[column.field]}}</router-link>
            </template>
            <template v-else>{{ customer[column.field] }}</template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import api from '@/api'
import { sortBy } from 'lodash'

export default {
  name: 'AdminCustomers',
  data: function () {
    return {
      customers: [],
      users: [],
      plans: [],
      searchText: '',
      sortFieldName: 'status',
      sortType: 'ASC',
      columns: [
        {
          field: 'name',
          name: 'Название'
        },
        {
          field: 'alias',
          name: 'Псевдоним'
        },
        {
          field: 'customersCount',
          name: 'Количество пользователей'
        },
        {
          field: 'adAgent',
          name: 'Количество РА'
        },
        {
          field: 'plan',
          name: 'Пакет'
        },
        {
          field: 'status',
          name: 'Статус клиента'
        }
      ]
    }
  },
  async created () {
    try {
      const [
        usersResponse,
        customerResponse,
        plansResponse
      ] = await Promise.all([
        api.get.users(),
        api.get.customers(),
        api.get.plans()
      ])
      this.users = usersResponse.data.data.users
      this.customers = customerResponse.data.data.customers
      this.plans = plansResponse.data.data.billingPlans
    } catch {}
  },
  computed: {
    sortedCustomers () {
      const customers = this.customers.map(this.mapCustomer)
      const sortedCustomers = sortBy(customers, (customer) => {
        return customer[this.sortFieldName]
      })

      if (this.sortType === 'DESC') {
        return sortedCustomers.reverse()
      }

      return sortedCustomers
    },
    filteredCustomers () {
      if (this.searchText) {
        return this.sortedCustomers.filter((f) =>
          Object.values(f).some(
            (x) => x.toString().toLowerCase().indexOf(this.searchText) >= 0
          )
        )
      }
      return this.sortedCustomers
    }
  },
  methods: {
    sortTable (fieldName) {
      if (fieldName === this.sortFieldName) {
        this.sortType = this.sortType === 'ASC' ? 'DESC' : 'ASC'
      } else {
        this.sortFieldName = fieldName
        this.sortType = 'ASC'
      }
    },
    async toggleCustomerStatus (status, id) {
      try {
        await api.post.updateCustomerInfo(id, { active: status })

        const index = this.customers.findIndex((cusomer) => cusomer.id === id)
        this.customers.splice(index, 1, {
          ...this.customers[index],
          active: status
        })
      } catch {
        this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        })
      }
    },
    async changePlan (id, planId) {
      try {
        await api.post.updateCustomerInfo(id, { billing_plan: planId })

        const index = this.customers.findIndex((cusomer) => cusomer.id === id)
        this.customers.splice(index, 1, {
          ...this.customers[index],
          billing_plan: { id: planId }
        })
        this.$notify({
          message: 'Тарифный план обновлен',
          type: 'success'
        })
      } catch {
        this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        })
      }
    },
    mapCustomer (customer) {
      return {
        id: customer.id,
        name: customer.name,
        alias: customer.alias,
        customersCount:
          this.users.find((user) => user.cid === customer.id)?.count ?? 0,
        adAgent:
          this.users.find((user) => user.cid === customer.id)?.adAgentCount ??
          0,
        plan: customer.billing_plan.id,
        status: customer.active
      }
    },
    clearSearchText () {
      this.searchText = ''
    }
  }
}
</script>

<style>
</style>
